import { render, staticRenderFns } from "./ThreadMessage.vue?vue&type=template&id=ef224670&scoped=true&"
import script from "./ThreadMessage.vue?vue&type=script&lang=js&"
export * from "./ThreadMessage.vue?vue&type=script&lang=js&"
import style0 from "./ThreadMessage.vue?vue&type=style&index=0&id=ef224670&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef224670",
  null
  
)

export default component.exports